module.exports = __webpack_public_path__ + "static/img/PC-2.243c00c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgzgk/PC-2.png
// module id = Nxjg
// module chunks = 0